import React from 'react';
import { Button, Modal } from 'antd';
import styled from 'styled-components';
import { useTranslation } from '../../../../i18n/useTranslation';

interface Props {
    errorLogs?: any;
    onClose: () => void;
}

const ErrorLogContainer = styled(Modal)`
    .ant-modal-body {
        max-height: 336px;
        overflow-y: scroll;
    }
`;

const ErrorLogCard = styled.div`
    background-color: #fdf6f5;
    padding: 16px;

    span {
        color: #4c4e54;
        font-size: 14px;
    }

    p {
        color: #d96758;
        margin: 0px;
    }
`;

function ErrorLogModal(props: Props) {
    const { t } = useTranslation();
    const { errorLogs, onClose } = props;
    const renderErrorLog = (header, message) => {
        return (
            <ErrorLogCard className="f-error-log-card mb-2" key={header}>
                <span>{header}</span>
                <p className="f-color-risk-very-high">{message}</p>
            </ErrorLogCard>
        );
    };

    return (
        <ErrorLogContainer
            open
            title={t('Error Log')}
            width={780}
            centered
            closable={false}
            onCancel={onClose}
            footer={
                <Button onClick={onClose} type="default">
                    {t('Close')}
                </Button>
            }
        >
            {errorLogs?.xlsxLogs?.map((log) => renderErrorLog(log.header, log.message))}

            {errorLogs?.missingHeaders?.map((headerMissing) =>
                renderErrorLog(
                    t(`Field '{{headerMissing}}' Missing`, { headerMissing }),
                    t(`Error: Field {{headerMissing}} is missing from the csv file`, { headerMissing }),
                ),
            )}

            {errorLogs?.unexpectedHeaders?.map((invalidHeader) => {
                if (invalidHeader) {
                    return renderErrorLog(
                        t(`Invalid '{{invalidHeader}}' Field`, { invalidHeader }),
                        t(`Error: {{invalidHeader}} is an invalid field`, { invalidHeader }),
                    );
                }
                return renderErrorLog(
                    t('Missing Field'),
                    t('Error: There is a value in file without column name or invalid column name.'),
                );
            })}

            {!errorLogs && (
                <ErrorLogCard className="f-error-log-card mb-2">
                    <span>{t('Invalid File Format')}</span>
                    <p className="f-color-risk-very-high">
                        {t('Error: The file uploaded is invalid, It must be in csv format')}
                    </p>
                </ErrorLogCard>
            )}
        </ErrorLogContainer>
    );
}

export default ErrorLogModal;
